export interface IProductRecommendations {
  productRecommendations: IProductRecommendation[];
}

export interface IProductRecommendation {
  id: string;
  name: any;
  description: any;
  expiryDate: string;
  startDate: number;
  endDate: number;
  urlImage: string;
  deepLinkType: ProductRecommendationsDeepLinkTypeEnum;
  imageName: string;
  submittedForApproval: boolean;
  data: {
    type: ProductRecommendationsActionTypeEnum;
    flow?: string; //NATIVE
    eventId?: string; //DYNAMIC_SCREEN
    uri?: string; //DEEPLINK & EXTERNAL_LINK
  };
}

export enum ProductRecommendationsDeepLinkTypeEnum {
  NATIVE = "NATIVE",
  DYNAMIC_SCREEN = "DYNAMIC_SCREEN",
  DEEP_LINK = "DEEP_LINK",
  EXTERNAL_LINK = "EXTERNAL_LINK",
}

export enum ProductRecommendationsActionTypeEnum {
  NATIVE = "NATIVE",
  DYNAMIC_SCREEN = "DYNAMIC_SCREEN",
  DEEP_LINK = "DEEP_LINK",
  EXTERNAL_LINK = "EXTERNAL_LINK",
  NONE = "NONE",
  BUNDLE = "BUNDLE",
  MINI_APP = "MINI_APP",
}

export enum ProductRecommendationsFlowEnum {
  SERVICES = "SERVICES",
  QR_CODE = "QR_CODE",
  PAY_PERSON = "PAY_PERSON",
  WITHDRAW_CASH = "WITHDRAW_CASH",
  WITHDRAW_AGENT = "WITHDRAW_AGENT",
  MPESA_POINTS = "MPESA_POINTS",
  PAY_MERCHANT = "PAY_MERCHANT",
  PAY_BUSINESS = "PAY_BUSINESS",
  PAY_LUKU = "PAY_LUKU",
  INTERNATIONAL_TRANSFERS = "INTERNATIONAL_TRANSFERS",
  BANK_TRANSFERS = "BANK_TRANSFERS",
  PAY_GOVERNMENT = "PAY_GOVERNMENT",
  AIRTIME_TOP_UP = "AIRTIME_TOP_UP",
  AIRTIME_TOP_UP_SELF = "AIRTIME_TOP_UP_SELF",
  AIRTIME_BUY_BUNDLE = "AIRTIME_BUY_BUNDLE",
  REVERSE_TRANSACTION = "REVERSE_TRANSACTION",
  SETTINGS = "SETTINGS",
  REFER_A_FRIEND = "REFER_A_FRIEND",
  CUSTOMIZE_MENUS = "CUSTOMIZE_MENUS",
  MPESA_FEES = "MPESA_FEES",
  CONTACT_VODACOM = "CONTACT_VODACOM",

  // Un-used not supported on the apps (remove translations in the future and move this to a shared enum)
  TOP_UP = "TOP_UP",
  WITHDRAW_ATM = "WITHDRAW_ATM",
  PAY_INTO_BANK = "PAY_INTO_BANK",
  BUNDLE = "BUNDLE",
  LUKU = "LUKU",
  DSTV = "DSTV",
  GOVERNMENT_BILL = "GOVERNMENT_BILL",
}
